// src/components/common/LoadingState.jsx
import "../../static/LoadingState.css";

const LoadingState = ({
    message = "Loading...",
    variant = "page",   // "page" | "inline" | "card"
    className = "",
}) => {
    return (
        <div className={`loading loading--${variant} ${className}`.trim()}>
            <div className="loading__spinner" aria-hidden="true" />
            {message && (
                <p className="loading__text" role="status">
                    {message}
                </p>
            )}
        </div>
    );
};

export default LoadingState;